import React, { useState, useEffect } from 'react'
import QrReaderComponent from 'react-qr-reader'
import { useNavigate } from 'react-router-dom'

import { Header, snackbar } from 'components'
import { ERRORS } from 'consts'
import { ReactComponent as TopLeftCorner } from 'assets/icons/top-left-corner.svg'
import { ReactComponent as TopRightCorner } from 'assets/icons/top-right-corner.svg'
import { ReactComponent as BottomLeftCorner } from 'assets/icons/bottom-left-corner.svg'
import { ReactComponent as BottomRightCorner } from 'assets/icons/bottom-right-corner.svg'
import { ReactComponent as CheckLogo } from 'assets/icons/check.svg'

import { ErrorModal } from './components'
import { useStyles } from './styles'

interface QrReaderProps {
  getUserByQrCode: (code: string, validateLastVisit: boolean) => Promise<void>
}

const QrReader: React.FC<QrReaderProps> = ({ getUserByQrCode }) => {
  const classes = useStyles()
  const [showCheck, setShowCheck] = useState(false)
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [qrData, setQrData] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!qrData) setOpenErrorModal(true)
    }, 45000)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const getUser = async () => {
      try {
        await getUserByQrCode(qrData, true)
        navigate(`/detail/${qrData}`)
      } catch (error) {
        const apiError = error as { message: string; type: string }
        const customMessage = 'CUSTOM_MESSAGE:'
        if (apiError.message.includes(customMessage)) {
          const updatedMessage = apiError.message.replace(customMessage, '')
          snackbar.show(updatedMessage)
        } else if (apiError.type === 'ResourceNotFound') {
          snackbar.show(ERRORS.QR_NOT_FOUND_MESSAGE)
          navigate('/home')
        } else setOpenErrorModal(true)
      }
    }

    if (qrData) {
      setShowCheck(true)
      getUser()
    }
  }, [qrData, navigate, getUserByQrCode])

  return (
    <div className={classes.container}>
      <Header />
      <div className={classes.qrView}>
        <div className={classes.overlay}>
          <TopLeftCorner width={30} height={30} className={classes.topLeftCorner} />
          <TopRightCorner width={30} height={30} className={classes.topRightCorner} />
          <BottomLeftCorner width={30} height={30} className={classes.bottomLeftCorner} />
          <BottomRightCorner width={30} height={30} className={classes.bottomRightCorner} />
          {showCheck && <CheckLogo width="100%" height="100%" className={classes.checkLogo} />}
        </div>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/* @ts-ignore */}
        <QrReaderComponent
          className={classes.qrReader}
          delay={300}
          showViewFinder={false}
          onError={() => setOpenErrorModal(true)}
          onScan={(data) => {
            if (data) setQrData(data)
          }}
        />
      </div>
      <ErrorModal open={openErrorModal} />
    </div>
  )
}

export { QrReader }
